var DynamicDialogStyle = {};

export { DynamicDialogStyle as default };
